<template>
  <div class="container">
    <p></p>
    <div class="titulo text-center">
      <h2><strong>REGISTRO DE AUTOMÓVILES</strong></h2>
    </div>
    <p></p>
    <div class="d-flex justify-content-between mb-3">
      <button v-if="!isFormVisible" @click="showForm" class="btn btn-success">
        <i class="bi bi-car-front icon"></i> Agregar Automóvil
      </button>

      <input
        v-model="searchQuery"
        type="text"
        class="form-control w-25"
        placeholder="Buscar"
      />
    </div>

    <div class="table-container">
      <table class="table table-striped table-hover table-bordered">
        <thead>
          <tr>
            <th>ID</th>
            <th>Marca</th>
            <th>Modelo</th>
            <th>Color</th>
            <th>Num. placa</th>
            <th>Año</th>
            <th>Tipo</th>
            <th>Capacidad Máxima</th>
            <th>Disponibilidad</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="auto in paginatedAutos" :key="auto.Id_auto">
            <td>{{ auto.Id_auto }}</td>
            <td>{{ auto.Marca }}</td>
            <td>{{ auto.Modelo }}</td>
            <td>{{ auto.Color }}</td>
            <td>{{ auto.Matricula }}</td>
            <td>{{ auto.Año }}</td>
            <td>{{ auto.Tipo }}</td>
            <td>{{ auto.Capacidad_maxima }}</td>
            <td>{{ auto.Disponibilidad_auto }}</td>
            <td>
              <button @click="editAuto(auto)" class="btn btn-link">
                <i class="bi bi-pencil-square"></i>
              </button>
              <button @click="deleteAuto(auto.Id_auto)" class="btn btn-link1">
                <i class="bi bi-trash-fill"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <nav aria-label="Page navigation example">
      <ul class="pagination justify-content-center">
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <button class="page-link" @click="changePage(currentPage - 1)">Anterior</button>
        </li>
        <li
          v-for="page in totalPages"
          :key="page"
          class="page-item"
          :class="{ active: page === currentPage }"
        >
          <button class="page-link" @click="changePage(page)">{{ page }}</button>
        </li>
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <button class="page-link" @click="changePage(currentPage + 1)">
            Siguiente
          </button>
        </li>
      </ul>
    </nav>

    <div v-if="isFormVisible" class="form-container">
      <h3>{{ isEditing ? "Editar Automóvil" : "Agregar Automóvil" }}</h3>
      <form @submit.prevent="isEditing ? submitEditForm() : submitForm()">
        <div class="form-group">
          <label for="marca">Marca</label>
          <input
            v-model="auto.Marca"
            type="text"
            id="marca"
            class="form-control"
            required
          />
        </div>
        <div class="form-group">
          <label for="modelo">Modelo</label>
          <input
            v-model="auto.Modelo"
            type="text"
            id="modelo"
            class="form-control"
            required
          />
        </div>
        <div class="form-group">
          <label for="color">Color</label>
          <input
            v-model="auto.Color"
            type="text"
            id="color"
            class="form-control"
            required
          />
        </div>
        <div class="form-group">
          <label for="matricula">Número de placa</label>
          <input
            v-model="auto.Matricula"
            type="text"
            id="matricula"
            class="form-control"
            required
          />
        </div>
        <div class="form-group">
          <label for="año">Año</label>
          <input
            v-model="auto.Año"
            type="number"
            id="año"
            class="form-control"
            required
          />
        </div>
        <div class="form-group">
          <label for="tipo">Tipo</label>
          <input
            v-model="auto.Tipo"
            type="text"
            id="tipo"
            class="form-control"
            required
          />
        </div>
        <div class="form-group">
          <label for="capacidadmax">Capacidad Máxima</label>
          <input
            v-model="auto.Capacidad_maxima"
            type="number"
            id="capacidadmax"
            class="form-control"
            required
          />
        </div>
        <div class="form-group">
          <label for="disponibilidad">Disponibilidad</label>
          <select
            v-model="auto.Disponibilidad_auto" 
            id="disponibilidad"
            class="form-control"
            required
          >
            <option value="Disponible">Disponible</option>
            <option value="No Disponible">No Disponible</option>
          </select>
        </div>
        <p></p>
        <button type="submit" class="btn btn-primary me-2">
          {{ isEditing ? "Actualizar" : "Guardar" }}
        </button>
        <button type="button" class="btn btn-secondary" @click="cancelForm">
          Cancelar
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      lista_autos: [],
      auto: {
        Id_auto: null,
        Marca: "",
        Modelo: "",
        Color: "",
        Matricula: "",
        Año: "",
        Tipo: "",
        Capacidad_maxima: "",
        Disponibilidad_auto: "",
      },
      isFormVisible: false,
      isEditing: false,
      searchQuery: "",
      currentPage: 1,
      itemsPerPage: 5,
    };
  },
  computed: {
    filteredAutos() {
      return this.lista_autos.filter((auto) => {
        const searchString = `${auto.Id_auto} ${auto.Marca} ${auto.Modelo} ${auto.Color} ${auto.Matricula} ${auto.Año} ${auto.Tipo} ${auto.Capacidad_maxima} ${auto.Disponibilidad_auto} `.toLowerCase();
        return searchString.includes(this.searchQuery.toLowerCase());
      });
    },
    paginatedAutos() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredAutos.slice(startIndex, startIndex + this.itemsPerPage);
    },
    totalPages() {
      return Math.ceil(this.filteredAutos.length / this.itemsPerPage);
    },
  },
  methods: {
  
    getAutos() {
      axios
        .get(
         this.$backendUrl+ "/index.php/autos/lista_completa"
        )
        .then((response) => {
          this.lista_autos = response.data;
        })
        .catch((error) => {
          if (error.response) {
            Swal.fire("Error", `Error al obtener automóviles: ${error.response.data.message}`, "error");
          } else {
            Swal.fire("Error", "Error al procesar la solicitud.", "error");
          }
        });
    },

    // Validar formulario antes de enviar
    validateForm() {
      const errors = [];

      if (!this.auto.Marca.trim()) errors.push("La marca es obligatoria.");
      if (!this.auto.Modelo.trim()) errors.push("El modelo es obligatorio.");
      if (!this.auto.Color.trim()) errors.push("El color es obligatorio.");
      if (!this.auto.Matricula.trim()) errors.push("La matrícula es obligatoria.");
      if (!this.auto.Año || this.auto.Año < 1990 || this.auto.Año > new Date().getFullYear()) {
        errors.push("El año debe ser un número válido.");
      }
      if (!this.auto.Capacidad_maxima || this.auto.Capacidad_maxima <= 0) {
        errors.push("La capacidad máxima debe ser un número positivo.");
      }

      if (errors.length > 0) {
        Swal.fire("Errores de Validación", errors.join("<br>"), "warning");
        return false;
      }

      return true;
    },

    // Enviar formulario para agregar auto
    submitForm() {
      if (this.validateForm()) {
        axios
          .post(
           this.$backendUrl+ "/index.php/autos/insertar",
            this.auto
          )
          .then(() => {
            this.getAutos();
            this.cancelForm();
            Swal.fire("Éxito", "Automóvil agregado correctamente.", "success");
          })
          .catch((error) => {
            Swal.fire("Error", "Error al agregar automóvil.", "error");
            console.error("Error al agregar automóvil:", error);
          });
      }
    },

    // Enviar formulario para editar auto
    submitEditForm() {
      if (this.validateForm()) {
        axios
          .put(
            this.$backendUrl+ "/index.php/autos/actualizar",
            this.auto
          )
          .then(() => {
            this.getAutos();
            this.cancelForm();
            Swal.fire("Éxito", "Automóvil actualizado correctamente.", "success");
          })
          .catch((error) => {
            Swal.fire("Error", "Error al editar automóvil.", "error");
            console.error("Error al editar automóvil:", error);
          });
      }
    },

    // Eliminar auto con confirmación
    deleteAuto(id) {
      Swal.fire({
        title: "¿Estás seguro?",
        text: "No podrás revertir esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete(this.$backendUrl+ "/index.php/autos/borrar", {
              data: { Id_auto: id },
            })
            .then(() => {
              this.getAutos();
              Swal.fire("Eliminado", "El automóvil ha sido eliminado.", "success");
            })
            .catch((error) => {
              Swal.fire("Error", "Error al eliminar automóvil.", "error");
              console.error("Error al eliminar automóvil:", error);
            });
        }
      });
    },

    // Mostrar formulario de agregar auto
    showForm() {
      this.isFormVisible = true;
      this.isEditing = false;
      this.resetForm();
    },

    // Mostrar formulario de edición
    editAuto(auto) {
      this.isEditing = true;
      this.isFormVisible = true;
      this.auto = { ...auto };
    },

    // Cancelar formulario
    cancelForm() {
      this.isFormVisible = false;
      this.isEditing = false;
      this.resetForm();
    },

    // Resetear el formulario
    resetForm() {
      this.auto = {
        Id_auto: null,
        Marca: "",
        Modelo: "",
        Color: "",
        Matricula: "",
        Año: "",
        Tipo: "",
        Capacidad_maxima: "",
        Disponibilidad_auto: "",
      };
    },

    // Cambiar página
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
  mounted() {
    this.getAutos();
  },
};
</script>


<style scoped>
.table-container {
  overflow-x: auto;
  margin-bottom: 20px;
  text-align: center;
}

.form-container {
  margin-top: 20px;
}

.pagination .page-link {
  cursor: pointer;
}

.titulo {
  background-color: #f52349;
  color: white;
  font-size: 18px;
  padding: 15px;
}

.btn-link {
  color: #2fc1f6;
  font-size: 150%;
  border: none;
}

.btn-link:hover {
  color: #ce13a2;
}

.btn-link1 {
  color: red;
  font-size: 150%;
  border: none;
}
</style>
